import React from 'react'
import { Modal } from '@mozartfinance/uikit'
import SlippageToleranceSetting from './SlippageToleranceSetting'
import TransactionDeadlineSetting from './TransactionDeadlineSetting'

type SettingsModalProps = {
  onDismiss?: () => void,
  translateString: (translationId: number, fallback: string) => (string)
}

// TODO: Fix UI Kit typings
const defaultOnDismiss = () => null

const SettingsModal = ({ onDismiss = defaultOnDismiss, translateString }: SettingsModalProps) => {
  return (
    <Modal title="Paramètres" onDismiss={onDismiss}>
      <SlippageToleranceSetting translateString={translateString}/>
      <TransactionDeadlineSetting translateString={translateString}/>
    </Modal>
  )
}

export default SettingsModal
